<template>
	<div class="pause-page">
		<div class="pause_bg">
			<div class="pause_contain">
				<div class="weekendpause_title_t">
          <span>周六日及节假日<br/>暂不能在线申请</span>
					<!-- <img src="../assets/weekend-pause-text.svg" /> -->
				</div>
				<div class="weekendpause_tip_t">
					<span>请在工作日进行申请</span>
					返回<span class="back_hoslist" @click="onShowHospitalList">【医院列表】</span>
				</div>
				<div class="weekendpause_image">
					<img src="../assets/weekend-pause-background.png" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {
			
		},
		methods:{
			onShowHospitalList(){
				this.$router.push('hos-list')
			}
		}
	}
</script>

<style>
	/* pages/pause/pause.wxss */
.pause_bg{
  background: white;
  width: 100%;
  height: 100vh;
}
.pause_contain{
  width: 90%;
  margin: 0px auto;
  padding-top: 60px;
 
}
.weekendpause_title_t{
  width: 100%;
  text-align:center;
  font-size: 36px;
  margin-bottom: 10px;
}
.weekendpause_title_t img{
  width: 320px;
  height: 136px;
}
.text_red{
  color: red;
}
.weekendpause_tip_t{
  width: 148px;
  text-align:left;
  margin: 0 auto;
  padding: 5px  5px;
  background: #E8F6E8;
}
.back_hoslist{
  color: #1AAD19;
}
.weekendpause_image{
  width: 100%;
  /* height: 194px; */
  margin: 80px auto;
}
.weekendpause_image img{
  width: 100%;
}
.pause_address{
  position: fixed;
  bottom: 40px;
  left: 20px;
  right: 20px;
}
.pause_address_title{
  margin-left: 15px;
  line-height: 32px;
}
.pause_address_title img{
  /* padding-top:3px;  */
  width: 25px;
  height: 25px;
}

.pause_address_contain{
  background: #F3FCFF;
  padding: 15px 15px;
}
</style>
